import React, { Component } from 'react';
import map from 'lodash.map';
import filter from 'lodash.filter';
import orderBy from 'lodash.orderby';
import 'react-vis/dist/style.css';
import {
	XYPlot,
	FlexibleXYPlot,
	VerticalGridLines,
	HorizontalGridLines,
	XAxis,
	YAxis,
	HorizontalBarSeries,
	LabelSeries,
	RadialChart,
	DiscreteColorLegend,
	Hint
} from 'react-vis';

const ColorSet = [ '#264796', '#E53A24', '#df9840', '#108bf0', '#d14221', '#EF7F1A' ];
const getColor = (index) => {
	if (index > ColorSet.length - 1) {
		return ColorSet[index % (ColorSet.length - 1)];
	}
	return ColorSet[index];
};

export class ChartPieWrapper extends Component {
	constructor(props) {
		super(props);
		this.state = {
			labelValue: false
		};
	}

	_forgetValue = () => {
		this.setState({
			labelValue: false
		});
	};

	_rememberValue = (value) => {
		this.setState({ labelValue: value });
	};

	render() {
		const { summaries = [] } = this.props;
		const { labelValue } = this.state;
		const data = map(summaries, (item, index) => ({ ...item, angle: item.percentage, color: getColor(index) }));
		return (
			<div className="chart-container">
				<RadialChart
					className="chart"
					colorType={'literal'}
					colorDomain={[ 0, 100 ]}
					colorRange={[ 0, 10 ]}
					margin={{ top: 100 }}
					getLabel={(item) => (item.percentage >= 5 ? `${item.percentage}%` : '')}
					data={data}
					labelsRadiusMultiplier={0.9}
					labelsStyle={{ fontSize: 11, fill: '#fff', color: '#000' }}
					showLabels
					width={200}
					height={200}
					onValueMouseOver={this._rememberValue}
					onValueMouseOut={this._forgetValue}
				>
					{labelValue && (
						<Hint value={labelValue}>
							<div className="rv-hint__content">
								<div key={`rv-hint`}>
									<span className="rv-hint__value">{labelValue.label}</span>
								</div>
							</div>
						</Hint>
					)}
				</RadialChart>
				<DiscreteColorLegend
					className="legend"
					colors={map(data, (item) => item.color)}
					items={map(data, (item) => item.label)}
				/>
			</div>
		);
	}
}

const getLabels = (data) =>
	data.map((item) => ({
		x: item.y,
		y: item.x
	}));

export class ChartBarWrapper extends Component {
	constructor(props) {
		super(props);
		this.state = {
			labelValue: false
		};
	}

	_forgetValue = () => {
		this.setState({
			labelValue: false
		});
	};

	_rememberValue = (value) => {
		this.setState({ labelValue: value });
	};

	render() {
		const { summaries = [] } = this.props;
		const { labelValue } = this.state;
		const data = map(summaries, (item, index) => ({
			x: item.y,
			y: item.x,
			title: `${item.x || 'Obszar'} - liczba głosów ${item.y}`,
			color: getColor(index)
		}));
		const chartData = filter(data, (item) => item.x > 0);
		const labels = getLabels(chartData);
		return (
			<div className="chart-container">
				<FlexibleXYPlot
					height="400"
					className="chart"
					yType="ordinal"
					yDistance={100}
					colorType={'literal'}
					colorDomain={[ 0, 100 ]}
					colorRange={[ 0, 10 ]}
					style={{ fontSize: 11, fill: '#fff', color: '#000' }}
				>
					<HorizontalGridLines />
					<VerticalGridLines />
					<XAxis tickValues={map(chartData, (item) => item.x)} />
					<YAxis hideTicks />
					<HorizontalBarSeries
						data={chartData}
						onValueMouseOver={this._rememberValue}
						onValueMouseOut={this._forgetValue}
					/>

					{labelValue && (
						<Hint value={labelValue}>
							<div className="rv-hint__content">
								<div key={`rv-hint`}>
									<span className="rv-hint__value">{labelValue.title}</span>
								</div>
							</div>
						</Hint>
					)}
				</FlexibleXYPlot>
				<DiscreteColorLegend
					className="legend"
					colors={map(data, (item, index) => getColor(index))}
					items={map(data, (item) => item.title)}
				/>
			</div>
		);
	}
}
